import script from "./AlunosObservacoes.vue?vue&type=script&setup=true&lang=js"
export * from "./AlunosObservacoes.vue?vue&type=script&setup=true&lang=js"

import "./AlunosObservacoes.vue?vue&type=style&index=0&id=beb6b29a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-beb6b29a"]])

export default __exports__